<template>
  <div>
    <div v-if="canInitVideoIdentication">
      <camera @initRecorder="initRecorder"></camera>
      <canvas id="canvas" width=640 height=480 class="centerHorizontalAbsolute"></canvas>
      <canvas id="canvasGuide" width=640 height=480 class="centerHorizontalAbsolute"></canvas>
      <canvas id="canvasMessages" width=640 height=480 class="centerHorizontalAbsolute"></canvas>
      <canvas id="canvasRectangle" width=640 height=480 class="centerHorizontalAbsolute"></canvas>
      <canvas id="canvasCheckMark" width=120 height=70 class="centerHorizontalAbsolute"></canvas>
      <canvas id="canvasRecordCircle" width=30 height=30 class="centerHorizontalAbsolute"></canvas>
      <canvas id="canvasLiveness" width=640 height=480 class="centerHorizontalAbsolute"></canvas>
      <canvas id="canvasVideo" width=640 height=480 class="centerHorizontalAbsolute"></canvas>
      <canvas id="images" class="pointCanvas centerHorizontalAbsolute" width=640 height=480></canvas>
    </div>
    <div v-if="!canInitVideoIdentication">
      <p class="esign-error-text" v-if="tokenMsg">El token es obligatorio para poder realizar la identificación.</p>
      <p class="esign-error-text" v-if="endPointMsg">El end point es un campo obligatorio para poder realizar la identificación.</p>
      <p class="esign-error-text" v-if="endPointVideoMsg">El end point del servicio de identificación es un campo obligatorio para poder realizar la identificación.</p>
      <p class="esign-error-text" v-if="domainUuidMsg">El identificador del dominio es un campo obligatorio para poder realizar la identificación.</p>
      <p class="esign-error-text" v-if="operationUuidMsg">El identificador de la operación es un campo obligatorio para poder realizar la identificación.</p>
    </div>
    <p id="snackbar-success"></p>
    <p id="snackbar-info"></p>
    <p id="snackbar-error"></p>
  </div>
</template>

<script>
// https://www.npmjs.com/package/recordrtc
import Camera from "./Camera";
import live from "@/utils/Liveness";
import axios from "axios";

let rtc = require("recordrtc");

export default {
  components: { Camera },
  props: {
    token: { type: String, required: true },
    endPoint: { type: String, required: true },
    endPointVideo: { type: String, required: true },
    operationUuid: { type: String, required: true },
    domainUuid: { type: String, required: true },
    country: { type: String, default: "ESP" },
    cedulaDocument: { type: Boolean, default: false },
    isPortrait: { type: Boolean, default: false },
    isPassport: { type: Boolean, default: false },
    doLivenessDetection: { type: Boolean, default: false },
    doFaceDetection: { type: Boolean, default: true },
    doRectangleDetection: { type: Boolean, default: false },
    doHologramDetection: { type: Boolean, default: true },
    doFrontDetection: { type: Boolean, default: true },
    doBackDetection: { type: Boolean, default: true },
    frontConfidence: { type: Number, default: 0.75 },
    hologramConfidence: { type: Number, default: 0.75 },
    backConfidence: { type: Number, default: 0.75 },
    biometry: { type: Boolean, default: true },
    biometryConfidence: { type: Number, default: 0.3 },
    biometryBlocking: { type: Boolean, default: false },
    pointsFront: { type: Number, default: 50 },
    pointsBack: { type: Number, default: 50 },
    withFaceRect: { type: Number, default: 150 },
    returnFaceImage: { type: Boolean, default: true },
    returnFrontImage: { type: Boolean, default: true },
    returnHologramImage: { type: Boolean, default: true },
    returnBackImage: { type: Boolean, default: true },
    returnFrontOcr: { type: Boolean, default: false },
    returnBackOcr: { type: Boolean, default: true },
    returnPassportImage: { type: Boolean, default: true },
    returnPassportMrzImage: { type: Boolean, default: true },
    returnPassportMrzOcr: { type: Boolean, default: true },
    videoTimeout: { type: Number, default: 3 },
    status: { type: Number, default: 0 },
    response: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    snackBar: { type: Boolean, default: false },
    identificationMessages: {
      type: Object,
      default: {
        initIdentification: "Starting identification",
        cannotInitIdentification: "It has not been possible to start  identification",
        livenessDetection: "Turn your head towards the yellow ball",
        livenessDetectionFinish: "Liveness detection completed",
        faceDetection: "Face detection",
        faceDetectionClose: "Bring your face closer",
        faceDetectionFinish: "Your face has been detected",
        passportDetection: "Show your passport",
        passportDetectionFinish: "Your passport has been detected",
        biometryBlocking: "Biometric recognition has not been passed",
        frontDetection: "Show the front of your ID document",
        frontDetectionAdjust: "Bring your document closer",
        frontDetectionFinish: "ID document front detected",
        backDetection: "Show the back of your ID document",
        backDetectionAdjust: "Bring your document closer",
        backDetectionFinish: "ID document back detected",
        identificationFinish: "Identification completed"
      }
    },
    snackBarMessages: {
      type: Object,
      default: {
        initRecordError: "It has not been possible to start the recording",
        startRecord: "Recording  started",
        timeoutIdentification: "The time for identification is over",
        successFaceMsg: "Your face has been detected",
        // errorFaceMsg: "Ha ocurrido un error al detectar la cara",
        successDocumentTypeMsg: "ID document type has been detected",
        // errorDocumentTypeMsg: "Ha ocurrido un error al detectar el tipo de documento",
        successFrontMsg: "ID document front  detected",
        // errorFrontMsg: "Ha ocurrido un error al detectar el anverso del documento",
        successBackMsg: "ID document back  detected",
        // errorBackMsg: "Ha ocurrido un error al detectar el reverso del documento",
        saveVideoSuccess:
          "Video has been saved and identification has been completed",
        saveVideoError: "It has not been possible to start the video",
        endVideoIdentificationMsg: "Video identification  completed"
      }
    }
  },
  data() {
    return {
      tokenMsg: false,
      endPointMsg: false,
      endPointVideoMsg: false,
      operationUuidMsg: false,
      domainUuidMsg: false,
      canInitVideoIdentication: false,
      endVideoTimeout: undefined,
      video: undefined,
      videoUuid: String,
      face: {},
      rectangle: {},
      documentType: {},
      front: {},
      hologram: {},
      back: {},
      dni: "",
      rejectOpMsg: "",
      canReject: true,
      isIdentificationEnded: false,
      isFaceDetection: true,
      isDocumentTypeDetection: false,
      isFrontDetection: false,
      isBackDetection: false,
      videoIdentificationInterval: undefined,
      windowWidth: 0,
      windowHeight: 0,
      isDesktop: true,
      isHD: false,
      vWidth: 640,
      vHeight: 480,
      canvasRect: undefined,
      contextRect: undefined,
      contextGuide: undefined,
      contextMessages: undefined,
      contextCheckMark: undefined,
      canvasRecordCircle: undefined,
      contextRecordCircle: undefined,
      recorder: {},
      stream: {},
      startVideoTime: Number,
      endVideoTime: Number,
      videoDuration: Number,
      lastTimeRecordCircle: performance.now(),
      intervalRecordCircle: undefined,
      circles: {},
      documentlabel: String,
      INFO_NEUTRAL_COLOR: "rgba(137, 137, 137, 0.6)",
      INFO_NEUTRAL_BORDER_COLOR: "rgb(137, 137, 137)",
      INFO_SUCCESS_COLOR: "rgba(208, 255, 134, 0.6)",
      INFO_SUCCESS_BORDER_COLOR: "rgb(208, 255, 134)",
      INFO_ERROR_COLOR: "rgba(255, 106, 106, 0.6)",
      INFO_ERROR_BORDER_COLOR: "rgb(255, 106, 106)",
      INFO_WHITE_TEXT: "white",
      INFO_BLACK_TEXT: "black",
      INFO_HEIGHT: "",
      INFO_WIDTH: ""
    };
  },
  created() {
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.tokenMsg =
      (typeof this.token === "undefined" || this.token === "") === true;
    this.endPointMsg =
      (typeof this.endPoint === "undefined" || this.endPoint === "") === true;
    this.endPointVideoMsg =
      (typeof this.endPointVideo === "undefined" ||
        this.endPointVideo === "") === true;
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    this.domainUuidMsg =
      (typeof this.domainUuid === "undefined" || this.domainUuid === "") ===
      true;
    if (
      this.tokenMsg === false &&
      this.endPointMsg === false &&
      this.endPointVideoMsg === false &&
      this.operationUuidMsg === false &&
      this.domainUuidMsg === false
    ) {
      this.canInitVideoIdentication = true;
    }
  },
  beforeDestroy() {
    this.closeCamera();
  },
  methods: {
    async initRecorder(stream) {
      this.canvasRecordCircle = document.getElementById("canvasRecordCircle");
      this.contextRecordCircle = this.canvasRecordCircle.getContext("2d");
      this.circles.red = {
        x: 15,
        y: 15,
        radius: 8,
        color: "red",
        visibleDuration: 1500,
        visibleCountdown: 0
      };
      this.animate();
      this.stream = stream;
      this.recorder = new rtc.RecordRTCPromisesHandler(stream, {
        type: "video"
      });
      this.initIdentification();
    },
    initIdentification() {
      this.INFO_HEIGHT = 445;
      this.INFO_WIDTH = 542;
      this.video = document.querySelector("#video");
      var interval = setInterval(() => {
        if (this.video.readyState === 4) {
          var canvasMessages = document.getElementById("canvasMessages");
          this.contextMessages = canvasMessages.getContext("2d");
          this.startVideoTime = new Date();
          this.recorder.startRecording();
          setTimeout(() => {
            this.startArchive();
          }, 5000);
          clearInterval(interval);
        }
      }, 500);
    },
    startArchive() {
      axios
        .post(`${this.endPoint}${"startidentification/"}${this.operationUuid}`)
        .then(
          responseSuccess => {
            console.log("Se ha cambiado el estado de la operación a grabando.");
            this.showInfoDetectionMessages(
              this.contextMessages,
              this.identificationMessages.initIdentification,
              this.INFO_WIDTH,
              this.INFO_HEIGHT,
              this.INFO_SUCCESS_BORDER_COLOR,
              this.INFO_SUCCESS_COLOR,
              this.INFO_BLACK_TEXT,
              this.isDesktop,
              this.isPortrait
            );
            this.videoUuid = responseSuccess.data.videouuid;
            this.$store.commit("setVideoUuid", this.videoUuid);
            setTimeout(() => {
              this.showRecordCircle(this.circles.red);
            }, 10);
            this.intervalRecordCircle = setInterval(() => {
              setTimeout(() => {
                this.showRecordCircle(this.circles.red);
              }, 10);
            }, 1750);
            if (this.snackBar) {
              this.$showSnackBar(
                "snackbar-info",
                this.snackBarMessages.startRecord
              );
            }
            setTimeout(() => {
              this.initDetections();
            }, 2000);
          },
          responseError => {
            this.errorInitStartRecord();
          }
        );
    },
    errorInitStartRecord() {
      console.log(
        "Ha ocurrido un error al cambiar el estado de la operación a grabando. ",
        responseError.response.status
      );
      this.cleanShowInfoDetectionMessages(
        this.contextMessages,
        this.vWidth,
        this.vHeight,
        0
      );
      this.showInfoDetectionMessages(
        this.contextMessages,
        this.identificationMessages.cannotInitIdentification,
        this.INFO_WIDTH,
        this.INFO_HEIGHT,
        this.INFO_ERROR_BORDER_COLOR,
        this.INFO_ERROR_COLOR,
        this.INFO_WHITE_TEXT,
        this.isDesktop,
        this.isPortrait
      );
      if (this.snackBar) {
        this.$showSnackBar(
          "snackbar-error",
          this.snackBarMessages.initRecordError
        );
      }
      this.closeCamera();
      this.setOperationStateToError();
      this.EventBus.$emit("notify", "hideLoading");
      this.EventBus.$emit("error");
    },
    initDetections() {
      setTimeout(() => {
        this.endVideoTimeout = setTimeout(() => {
          this.stopRecording();
          if (this.snackBar) {
            this.$showSnackBar(
              "snackbar-info",
              this.snackBarMessages.timeoutIdentification
            );
          }
          this.setOperationStateToError();
        }, this.videoTimeout * 60000);
        if (this.doLivenessDetection) {
          this.cleanShowInfoDetectionMessages(
            this.contextMessages,
            this.vWidth,
            this.vHeight,
            0
          );
          this.showInfoDetectionMessages(
            this.contextMessages,
            this.identificationMessages.livenessDetection,
            this.INFO_WIDTH,
            this.INFO_HEIGHT,
            this.INFO_NEUTRAL_BORDER_COLOR,
            this.INFO_NEUTRAL_COLOR,
            this.INFO_WHITE_TEXT,
            this.isDesktop,
            this.isPortrait
          );
          this.livenessDetection();
        } else if (this.doFaceDetection) {
          this.cleanShowInfoDetectionMessages(
            this.contextMessages,
            this.vWidth,
            this.vHeight,
            0
          );
          this.showInfoDetectionMessages(
            this.contextMessages,
            this.identificationMessages.faceDetection,
            this.INFO_WIDTH,
            this.INFO_HEIGHT,
            this.INFO_NEUTRAL_BORDER_COLOR,
            this.INFO_NEUTRAL_COLOR,
            this.INFO_WHITE_TEXT,
            this.isDesktop,
            this.isPortrait
          );
          this.faceDetection();
        } else if (this.doFrontDetection) {
          if (this.country === "ESP") {
            this.frontDeepDetection();
          } else if (this.country === "ITA") {
            if (this.doRectangleDetection) {
              this.rectangleDetection();
            }
            this.dni = "carta2016";
            this.frontDetection();
            this.insertGuideOverVideo();
          } else {
            if (this.doRectangleDetection) {
              this.rectangleDetection();
            }
            this.documentTypeDetection();
          }
        } else if (this.doBackDetection) {
          if (this.country === "ESP") {
            this.backDeepDetection();
          } else {
            if (!this.doFrontDetection) {
              this.insertGuideOverVideo();
            }
            if (this.doRectangleDetection) {
              this.rectangleDetection();
            }
            this.backDetection();
          }
        }
      }, 2000);
    },
    captureImageFromVideo() {
      var canvas = document.querySelector("#canvas");
      canvas
        .getContext("2d")
        .drawImage(
          this.video,
          0,
          0,
          this.video.clientWidth,
          this.video.clientHeight
        );
      return canvas.toDataURL();
    },
    livenessDetection() {
      live.mainLifeTest(this.vWidth, this.vHeight, this);
      this.$on("testLive", data => {
        if (data.finish) {
          // this.cleanCanvas(this.contextMessages, this.vWidth, this.vHeight);
          this.cleanShowInfoDetectionMessages(
            this.contextMessages,
            this.vWidth,
            this.vHeight,
            0
          );
          this.showInfoDetectionMessages(
            this.contextMessages,
            this.identificationMessages.livenessDetectionFinish,
            this.INFO_WIDTH,
            this.INFO_HEIGHT,
            this.INFO_SUCCESS_BORDER_COLOR,
            this.INFO_SUCCESS_COLOR,
            this.INFO_BLACK_TEXT,
            this.isDesktop,
            this.isPortrait
          );
          this.drawCheckMark("canvasCheckMark");
          setTimeout(() => {
            this.cleanCanvas(this.contextCheckMark, this.vWidth, this.vHeight);
            this.cleanShowInfoDetectionMessages(
              this.contextMessages,
              this.vWidth,
              this.vHeight,
              0
            );
            this.showInfoDetectionMessages(
              this.contextMessages,
              this.identificationMessages.faceDetection,
              this.INFO_WIDTH,
              this.INFO_HEIGHT,
              this.INFO_NEUTRAL_BORDER_COLOR,
              this.INFO_NEUTRAL_COLOR,
              this.INFO_WHITE_TEXT,
              this.isDesktop,
              this.isPortrait
            );
            this.faceDetection();
          }, 2000);
        }
      });
    },
    faceDetection() {
      this.face.type = "face";
      this.face.uuid = this.operationUuid;
      this.face.returnFaceImg = this.returnFaceImage;
      this.face.customerid = this.customerId;
      this.face.widthFaceRect = this.withFaceRect;
      this.face.country = this.country;
      this.face.biometry = this.biometry;
      this.face.blink = this.blink;
      this.face.imgb64 = this.captureImageFromVideo();
      // axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(`${this.endPointVideo}${"/detection/face"}`, this.face, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            if (responseSuccess.data.detected) {
              let identificationData = this.prepareIdentificationData(
                responseSuccess,
                "FACE",
                this.returnFaceImage,
                this.biometry
              );
              this.saveDataInCapturedImage(identificationData);
              this.drawCheckMark("canvasCheckMark");
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight,
                0
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.faceDetectionFinish,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_SUCCESS_BORDER_COLOR,
                this.INFO_SUCCESS_COLOR,
                this.INFO_BLACK_TEXT,
                this.isDesktop,
                this.isPortrait
              );
              this.drawRectanglesOverVideo(
                "canvasRectangle",
                responseSuccess.data,
                "face"
              );
              this.isFaceDetection = false;
              this.isDocumentTypeDetection = true;
              setTimeout(() => {
                this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
                this.cleanShowInfoDetectionMessages(
                  this.contextMessages,
                  this.vWidth,
                  this.vHeight,
                  0
                );
                if (this.isPassport) {
                  this.showInfoDetectionMessages(
                    this.contextMessages,
                    this.identificationMessages.passportDetection,
                    this.INFO_WIDTH,
                    this.INFO_HEIGHT,
                    this.INFO_NEUTRAL_BORDER_COLOR,
                    this.INFO_NEUTRAL_COLOR,
                    this.INFO_WHITE_TEXT,
                    this.isDesktop,
                    this.isPortrait
                  );
                } else {
                  this.showInfoDetectionMessages(
                    this.contextMessages,
                    this.identificationMessages.frontDetection,
                    this.INFO_WIDTH,
                    this.INFO_HEIGHT,
                    this.INFO_NEUTRAL_BORDER_COLOR,
                    this.INFO_NEUTRAL_COLOR,
                    this.INFO_WHITE_TEXT,
                    this.isDesktop,
                    this.isPortrait
                  );
                }
              }, 2500);
              setTimeout(() => {
                this.cleanCanvas(
                  this.contextCheckMark,
                  this.vWidth,
                  this.vHeight
                );
                if (this.isPassport) {
                  this.passportDetection();
                } else if (this.country === "ESP") {
                  this.frontDeepDetection();
                } else {
                  this.insertGuideOverVideo();
                  if (this.doRectangleDetection) {
                    this.rectangleDetection();
                  }
                  this.frontDetection();
                }
              }, 2000);
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.successFaceMsg
                );
              }
            } else {
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight,
                0
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.faceDetectionClose,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_NEUTRAL_BORDER_COLOR,
                this.INFO_NEUTRAL_COLOR,
                this.INFO_WHITE_TEXT,
                this.isDesktop,
                this.isPortrait
              );
              this.faceDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.faceDetection();
            }
          }
        );
    },
    drawRectanglesOverVideo(canvasId, { x1, x2, y1, y2 }, type) {
      this.canvasRect = document.getElementById(canvasId);
      this.contextRect = this.canvasRect.getContext("2d");
      this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
      this.contextRect.beginPath();
      this.contextRect.lineWidth = "3";
      this.contextRect.strokeStyle = "rgb(109, 230, 186)";
      if (type === "face") {
        this.contextRect.translate(this.vWidth, 0);
        this.contextRect.scale(-1, 1);
        this.contextRect.rect(x1, y1, x2 - x1, y2 - y1);
      } else if (type === "rectangle") {
        this.contextRect.rect(x1, y1, x2 - x1, y2 - y1);
      } else {
        // this.contextRect.translate(this.vWidth, 0);
        // this.contextRect.scale(-1, 1);
        this.contextRect.rect(x2, x1, y1, y2);
      }
      this.contextRect.stroke();
    },
    insertGuideOverVideo() {
      var canvasGuide = document.getElementById("canvasGuide");
      this.contextGuide = canvasGuide.getContext("2d");
      var ar = this.calculateAspectRatio(
        this.vWidth,
        this.vHeight,
        this.cedulaDocument,
        this.isDesktop,
        this.isHD
      );
      var co = this.calculateCanvasPosition(
        this.vWidth,
        this.vHeight,
        ar.arWidth,
        ar.arHeight
      );
      setTimeout(() => {
        // document.getElementById("video").classList.add('videoNoTransition');
        // document.getElementById("video").classList.remove('videoTransition');
        this.insertCanvasOverVideo(
          canvasGuide,
          this.contextGuide,
          this.vWidth,
          this.vHeight,
          ar.arWidth,
          ar.arHeight,
          co.x,
          co.y
        );
      }, 25);
    },
    rectangleDetection() {
      this.rectangle.cedulaDocument = false;
      this.rectangle.isPortrait = false;
      this.rectangle.imgb64 = this.captureImageFromVideo();
      // axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(
          `${this.endPointVideo}${"/detection/rectangle"}`,
          this.rectangle,
          { headers: { "Content-type": "Application/json" } }
        )
        .then(
          responseSuccess => {
            if (!this.isIdentificationEnded) {
              this.drawRectanglesOverVideo(
                "canvasRectangle",
                responseSuccess.data,
                "rectangle"
              );
              if (this.doRectangleDetection) {
                this.rectangleDetection();
              }
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.rectangleDetection();
            }
          }
        );
    },
    passportDetection() {
      let passport = {};
      passport.imgb64 = this.captureImageFromVideo();
      passport.returnPassportImg = this.returnPassportImage;
      passport.returnMrzImg = this.returnPassportMrzImage;
      passport.biometry = this.biometry;
      axios
        .post(`${this.endPointVideo}${"/detection/passport"}`, passport)
        .then(
          responseSuccess => {
            if (responseSuccess.data.detected) {
              let identificationData = this.prepareIdentificationData(
                responseSuccess,
                "PASSPORT",
                this.returnPassportImage,
                this.biometry
              );
              this.saveDataInCapturedImage(identificationData);
              this.drawCheckMark("canvasCheckMark");
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight,
                0
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.passportDetectionFinish,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_SUCCESS_BORDER_COLOR,
                this.INFO_SUCCESS_COLOR,
                this.INFO_BLACK_TEXT,
                this.isDesktop,
                this.isPortrait
              );
              let mrzData = this.prepareIdentificationData(
                responseSuccess,
                "PASSPORTMRZ",
                this.returnPassportMrzImage,
                false
              );
              this.saveDataInCapturedImage(mrzData);
              this.stopRecording();
              setTimeout(() => {
                this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
                this.cleanCanvas(
                  this.contextCheckMark,
                  this.vWidth,
                  this.vHeight
                );
                this.cleanShowInfoDetectionMessages(
                  this.contextMessages,
                  this.vWidth,
                  this.vHeight,
                  0
                );
                this.showInfoDetectionMessages(
                  this.contextMessages,
                  this.identificationMessages.identificationFinish,
                  this.INFO_WIDTH,
                  this.INFO_HEIGHT,
                  this.INFO_SUCCESS_BORDER_COLOR,
                  this.INFO_SUCCESS_COLOR,
                  this.INFO_BLACK_TEXT,
                  this.isDesktop,
                  this.isPortrait
                );
                if (this.snackBar) {
                  this.$showSnackBar(
                    "snackbar-success",
                    this.snackBarMessages.endVideoIdentificationMsg
                  );
                }
              }, 2000);
            } else {
              this.passportDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.passportDetection();
            }
          }
        );
    },
    documentTypeDetection() {
      this.documentType.uuid = this.operationUuid;
      this.documentType.customerid = this.customerId;
      this.documentType.biometry = this.biometry;
      this.documentType.country = this.country;
      this.documentType.cedulaDocument = this.cedulaDocument;
      this.documentType.isPortrait = this.isPortrait;
      this.documentType.imgb64 = this.captureImageFromVideo();
      // axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(
          `${this.endPointVideo}${"/detection/document"}`,
          this.documentType,
          { headers: { "Content-type": "Application/json" } }
        )
        .then(
          responseSuccess => {
            if (responseSuccess.data.detected) {
              this.dni = responseSuccess.data.dni;
              this.isDocumentTypeDetection = false;
              this.isFrontDetection = true;
              setTimeout(() => {
                if (this.country === "ESP") {
                  this.frontDeepDetection();
                } else {
                  this.frontDetection();
                }
              }, 2000);
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.successDocumentTypeMsg
                );
              }
            } else if (!responseSuccess.data.detected) {
              if (this.country === "ESP") {
                this.frontDeepDetection();
              } else {
                this.documentTypeDetection();
              }
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.documentTypeDetection();
            }
          }
        );
    },
    faceBiometryValidation(confidence) {
      if (confidence >= this.biometryConfidence) {
        this.EventBus.$emit("biometry");
      } else {
        this.stopRecording();
        clearInterval(this.videoIdentificationInterval);
        this.isIdentificationEnded = true;
        this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight,
          0
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.biometryBlocking,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_ERROR_BORDER_COLOR,
          this.INFO_ERROR_COLOR,
          this.INFO_WHITE_TEXT,
          this.isDesktop,
          this.isPortrait
        );
        this.EventBus.$emit("biometryBlocking");
      }
    },
    frontDetection() {
      this.loadFrontData();
      // axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(`${this.endPointVideo}${"/detection/front"}`, this.front, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            if (
              this.doHologramDetection &&
              responseSuccess.data.detected &&
              (responseSuccess.data.documenttype === "dni_3_anverso" ||
                responseSuccess.data.documenttype === "dni_2_anverso")
            ) {
              let identificationData = this.prepareIdentificationData(
                responseSuccess,
                "DNIFRONT",
                this.returnFrontImg,
                this.biometry
              );
              this.saveDataInCapturedImage(identificationData);
              this.documentlabel =
                responseSuccess.data.documenttype.split("_")[0] +
                responseSuccess.data.documenttype.split("_")[1];
              if (this.biometryBlocking) {
                this.faceBiometryValidation(
                  responseSuccess.data.biometryData.confidence
                );
              }
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.successFrontMsg
                );
              }
              this.hologramDetection();
            } else if (
              this.doHologramDetection &&
              responseSuccess.data.detected &&
              (responseSuccess.data.documenttype === "dni_3_anverso" ||
                responseSuccess.data.documenttype === "dni_2_anverso")
            ) {
              this.logicPostDetectFront(responseSuccess);
            } else {
              this.frontDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.frontDetection();
            }
          }
        );
    },
    frontDeepDetection() {
      this.loadFrontData();
      // axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(`${this.endPointVideo}${"/detection/dl/front"}`, this.front, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            if (
              this.doHologramDetection &&
              responseSuccess.data.detected &&
              (responseSuccess.data.documenttype === "dni_3_anverso" ||
                responseSuccess.data.documenttype === "dni_2_anverso")
            ) {
              let identificationData = this.prepareIdentificationData(
                responseSuccess,
                "DNIFRONT",
                this.returnFrontImage,
                this.biometry
              );
              this.saveDataInCapturedImage(identificationData);
              responseSuccess.data.x1 = responseSuccess.data.top;
              responseSuccess.data.x2 = responseSuccess.data.left;
              responseSuccess.data.y1 = responseSuccess.data.width;
              responseSuccess.data.y2 = responseSuccess.data.height;
              this.drawRectanglesOverVideo(
                "canvasRectangle",
                responseSuccess.data,
                "front"
              );
              this.documentlabel =
                responseSuccess.data.documenttype.split("_")[0] +
                responseSuccess.data.documenttype.split("_")[1];
              if (this.biometryBlocking) {
                this.faceBiometryValidation(
                  responseSuccess.data.biometryData.confidence
                );
              }
              this.hologramDetection();
            } else if (
              this.doHologramDetection &&
              responseSuccess.data.detected &&
              (responseSuccess.data.documenttype === "dni_3_anverso" ||
                responseSuccess.data.documenttype === "dni_2_anverso")
            ) {
              this.logicPostDetectFront(responseSuccess);
            } else {
              this.frontDeepDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.frontDeepDetection();
            }
          }
        );
    },
    loadFrontData() {
      this.front.uuid = this.operationUuid;
      this.front.returnFrontImg = this.returnFrontImage;
      this.front.returnFrontOcr = this.returnFrontOcr;
      this.front.dni = this.dni;
      this.front.biometry = this.biometry;
      this.front.customerid = this.customerId;
      this.front.pointsFront = this.pointsFront;
      this.front.hologram = this.hologram;
      this.front.country = this.country;
      this.front.cedulaDocument = this.cedulaDocument;
      this.front.isPortrait = this.isPortrait;
      this.front.imgb64 = this.captureImageFromVideo();
      this.front.frontConfidence = this.frontConfidence;
    },
    logicPostDetectFront(responseSuccess) {
      if (responseSuccess.data.detected) {
        this.drawCheckMark("canvasCheckMark");
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight,
          0
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.frontDetectionFinish,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_SUCCESS_BORDER_COLOR,
          this.INFO_SUCCESS_COLOR,
          this.INFO_BLACK_TEXT,
          this.isDesktop,
          this.isPortrait
        );
        this.isFrontDetection = false;
        this.isBackDetection = true;
        setTimeout(() => {
          this.cleanShowInfoDetectionMessages(
            this.contextMessages,
            this.vWidth,
            this.vHeight,
            0
          );
          this.showInfoDetectionMessages(
            this.contextMessages,
            this.identificationMessages.backDetection,
            this.INFO_WIDTH,
            this.INFO_HEIGHT,
            this.INFO_NEUTRAL_BORDER_COLOR,
            this.INFO_NEUTRAL_COLOR,
            this.INFO_WHITE_TEXT,
            this.isDesktop,
            this.isPortrait
          );
        }, 2500);
        setTimeout(() => {
          this.cleanCanvas(this.contextCheckMark, this.vWidth, this.vHeight);
          this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
          if (this.country === "ESP") {
            this.backDeepDetection();
          } else {
            this.backDetection();
          }
        }, 2000);
      } else {
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight,
          0
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.frontDetectionAdjust,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_NEUTRAL_BORDER_COLOR,
          this.INFO_NEUTRAL_COLOR,
          this.INFO_WHITE_TEXT,
          this.isDesktop,
          this.isPortrait
        );
        if (this.country === "ESP") {
          this.frontDeepDetection();
        } else {
          this.frontDetection();
        }
      }
    },
    hologramDetection() {
      this.hologram.dni = this.documentlabel;
      this.hologram.returnHologramImg = this.returnHologramImage;
      this.hologram.hologramConfidence = this.hologramConfidence;
      this.hologram.country = this.country;
      this.hologram.imgb64 = this.captureImageFromVideo();
      axios
        .post(`${this.endPointVideo}${"/detection/hologram"}`, this.hologram, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            if (
              responseSuccess.data.detected &&
              (responseSuccess.data.documenttype === "dni_3_holograma" ||
                responseSuccess.data.documenttype === "dni_2_holograma")
            ) {
              let identificationData = this.prepareIdentificationData(
                responseSuccess,
                "HOLOGRAM",
                this.returnHologramImage,
                false
              );
              this.saveDataInCapturedImage(identificationData);
              responseSuccess.data.x1 = responseSuccess.data.top;
              responseSuccess.data.x2 = responseSuccess.data.left;
              responseSuccess.data.y1 = responseSuccess.data.width;
              responseSuccess.data.y2 = responseSuccess.data.height;
              this.drawRectanglesOverVideo(
                "canvasRectangle",
                responseSuccess.data,
                "hologram"
              );
              this.drawCheckMark("canvasCheckMark");
              this.cleanShowInfoDetectionMessages(
                this.contextMessages,
                this.vWidth,
                this.vHeight,
                0
              );
              this.showInfoDetectionMessages(
                this.contextMessages,
                this.identificationMessages.frontDetectionFinish,
                this.INFO_WIDTH,
                this.INFO_HEIGHT,
                this.INFO_SUCCESS_BORDER_COLOR,
                this.INFO_SUCCESS_COLOR,
                this.INFO_BLACK_TEXT,
                this.isDesktop,
                this.isPortrait
              );
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.successFrontMsg
                );
              }
              setTimeout(() => {
                this.cleanShowInfoDetectionMessages(
                  this.contextMessages,
                  this.vWidth,
                  this.vHeight,
                  0
                );
                this.showInfoDetectionMessages(
                  this.contextMessages,
                  this.identificationMessages.backDetection,
                  this.INFO_WIDTH,
                  this.INFO_HEIGHT,
                  this.INFO_NEUTRAL_BORDER_COLOR,
                  this.INFO_NEUTRAL_COLOR,
                  this.INFO_WHITE_TEXT,
                  this.isDesktop,
                  this.isPortrait
                );
              }, 2500);
              setTimeout(() => {
                this.cleanCanvas(
                  this.contextCheckMark,
                  this.vWidth,
                  this.vHeight
                );
                this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
                if (this.country === "ESP") {
                  this.backDeepDetection();
                } else {
                  this.backDetection();
                }
              }, 2000);
            } else {
              this.hologramDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.hologramDetection();
            }
          }
        );
    },
    backDetection() {
      this.loadBackData();
      // axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(`${this.endPointVideo}${"/detection/back"}`, this.back, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            let identificationData = this.prepareIdentificationData(
              responseSuccess,
              "DNIBACK",
              this.returnBackImage,
              false
            );
            this.saveDataInCapturedImage(identificationData);
            this.logicPostDetectBack(responseSuccess);
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.backDetection();
            }
          }
        );
    },
    backDeepDetection() {
      this.loadBackData();
      // axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(`${this.endPointVideo}${"/detection/dl/back"}`, this.back, {
          headers: { "Content-type": "Application/json" }
        })
        .then(
          responseSuccess => {
            if (
              responseSuccess.data.detected &&
              (responseSuccess.data.documenttype === "dni_3_reverso" ||
                responseSuccess.data.documenttype === "dni_2_reverso")
            ) {
              let identificationData = this.prepareIdentificationData(
                responseSuccess,
                "DNIBACK",
                this.returnBackImage,
                false
              );
              this.saveDataInCapturedImage(identificationData);
              responseSuccess.data.x1 = responseSuccess.data.top;
              responseSuccess.data.x2 = responseSuccess.data.left;
              responseSuccess.data.y1 = responseSuccess.data.width;
              responseSuccess.data.y2 = responseSuccess.data.height;
              this.drawRectanglesOverVideo(
                "canvasRectangle",
                responseSuccess.data,
                "back"
              );
              this.logicPostDetectBack(responseSuccess);
            } else {
              this.backDeepDetection();
            }
          },
          responseError => {
            if (!this.isIdentificationEnded) {
              this.backDeepDetection();
            }
          }
        );
    },
    loadBackData() {
      this.back.uuid = this.operationUuid;
      this.back.returnBackImg = this.returnBackImage;
      this.back.returnBackOcr = this.returnBackOcr;
      this.back.dni = this.dni;
      this.back.customerid = this.customerId;
      this.back.pointsBack = this.pointsBack;
      this.back.country = this.country;
      this.back.cedulaDocument = this.cedulaDocument;
      this.back.isPortrait = this.isPortrait;
      this.back.imgb64 = this.captureImageFromVideo();
      this.back.backConfidence = this.backConfidence;
    },
    logicPostDetectBack(responseSuccess) {
      if (responseSuccess.data.detected) {
        if (this.snackBar) {
          this.$showSnackBar(
            "snackbar-success",
            this.snackBarMessages.successBackMsg
          );
        }
        this.drawCheckMark("canvasCheckMark");
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight,
          0
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.backDetectionFinish,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_SUCCESS_BORDER_COLOR,
          this.INFO_SUCCESS_COLOR,
          this.INFO_BLACK_TEXT,
          this.isDesktop,
          this.isPortrait
        );
        this.isBackDetection = false;
        this.isIdentificationEnded = true;
        this.stopRecording();
        clearInterval(this.videoIdentificationInterval);
        if (this.snackBar) {
          this.$showSnackBar(
            "snackbar-success",
            this.snackBarMessages.successBackMsg
          );
        }
        setTimeout(() => {
          if (this.country !== "ESP") {
            this.cleanCanvas(this.contextGuide, this.vWidth, this.vHeight);
          }
          this.cleanCanvas(this.contextRect, this.vWidth, this.vHeight);
          this.cleanCanvas(this.contextCheckMark, this.vWidth, this.vHeight);
          this.cleanShowInfoDetectionMessages(
            this.contextMessages,
            this.vWidth,
            this.vHeight,
            0
          );
          this.showInfoDetectionMessages(
            this.contextMessages,
            this.identificationMessages.identificationFinish,
            this.INFO_WIDTH,
            this.INFO_HEIGHT,
            this.INFO_SUCCESS_BORDER_COLOR,
            this.INFO_SUCCESS_COLOR,
            this.INFO_BLACK_TEXT,
            this.isDesktop,
            this.isPortrait
          );
          if (this.snackBar) {
            this.$showSnackBar(
              "snackbar-success",
              this.snackBarMessages.endVideoIdentificationMsg
            );
          }
        }, 2000);
      } else {
        this.cleanShowInfoDetectionMessages(
          this.contextMessages,
          this.vWidth,
          this.vHeight,
          0
        );
        this.showInfoDetectionMessages(
          this.contextMessages,
          this.identificationMessages.backDetectionAdjust,
          this.INFO_WIDTH,
          this.INFO_HEIGHT,
          this.INFO_NEUTRAL_BORDER_COLOR,
          this.INFO_NEUTRAL_COLOR,
          this.INFO_WHITE_TEXT,
          this.isDesktop,
          this.isPortrait
        );
        if (this.country === "ESP") {
          this.backDeepDetection();
        } else {
          this.backDetection();
        }
      }
    },
    prepareIdentificationData(response, type, image, biometry) {
      let identificationData = {};
      identificationData.operationUuid = this.operationUuid;
      identificationData.documentType = type;
      if ((type === "DNIFRONT" || type === "PASSPORT") && biometry) {
        response.data.biometryData.frontConfidence = response.data.confidence;
      } else if (type === "DNIFRONT" && !biometry) {
        response.data.biometryData = {};
        response.data.biometryData.frontConfidence = response.data.confidence;
      }
      if ((type === "FACE" || type === "DNIFRONT") && biometry) {
        identificationData.metadata = JSON.stringify(
          response.data.biometryData
        );
      }
      if (type === "HOLOGRAM" && this.doHologramDetection) {
        identificationData.metadata = JSON.stringify(response.data.confidence);
      }
      if (
        (type === "DNIBACK" || type === "PASSPORTMRZ") &&
        (this.returnBackOcr || this.returnPassportMrzOcr)
      ) {
        response.data.ocr.backConfidence = response.data.confidence;
        identificationData.metadata = JSON.stringify(response.data.ocr);
      } else if (
        (type === "DNIBACK" || type === "PASSPORTMRZ") &&
        (!this.returnBackOcr || !this.returnPassportMrzOcr)
      ) {
        response.data.ocr = {};
        response.data.ocr.backConfidence = response.data.confidence;
        identificationData.metadata = JSON.stringify(response.data.ocr);
      }
      if (image) {
        identificationData.documentB64 = response.data.imagebase64.split(
          ","
        )[1];
      }
      return identificationData;
    },
    saveDataInCapturedImage(identificationData) {
      //   axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(
          `${this.endPoint}${"saveidentificationdata/"}${
            this.operationUuid
          }${"/"}${this.videoUuid}`,
          identificationData
        )
        .then(
          () => {
            console.log("Captured Data OK");
          },
          () => {
            console.log("Captured Data KO");
          }
        );
    },
    // Calculate aspect ratio to draw rectangle over video
    calculateAspectRatio(videoWidth, videoHeight, isCedula, isDesktop, isHD) {
      var arWidth = videoWidth;
      var arHeight = videoHeight;
      var result;
      result = this.getAspectRatio(
        arWidth,
        arHeight,
        videoWidth,
        videoHeight,
        isCedula,
        isHD,
        isDesktop
      );
      return { arWidth: result.arWidth, arHeight: result.arHeight };
    },
    getAspectRatio(
      arWidth,
      arHeight,
      videoWidth,
      videoHeight,
      isCedula,
      isHD,
      isDesktop
    ) {
      var result = this.calculateAspectRatioDocuments(
        arWidth,
        arHeight,
        videoWidth,
        videoHeight,
        isDesktop
      );
      if (isCedula) {
        if (isHD) {
          result = this.getMaxAspectRatioOverVideo(
            result.arWidth,
            result.arHeight,
            videoWidth,
            videoHeight,
            isCedula,
            1.1
          );
        } else {
          result = this.getMaxAspectRatioOverVideo(
            result.arWidth,
            result.arHeight,
            videoWidth,
            videoHeight,
            isCedula,
            1.4
          );
        }
      } else {
        result = this.getMaxAspectRatioOverVideo(
          result.arWidth,
          result.arHeight,
          videoWidth,
          videoHeight,
          isCedula,
          1.6
        );
      }
      return { arWidth: result.arWidth, arHeight: result.arHeight };
    },
    calculateAspectRatioDocuments(
      arWidth,
      arHeight,
      videoWidth,
      videoHeight,
      isDesktop
    ) {
      var result;
      var i = 2;
      var arH;
      var arW;
      if (!isDesktop) {
        if (arHeight === videoHeight && arWidth === videoWidth) {
          // mobile
          arH = 150;
          arW = 240;
        } else {
          result = this.getRatio(arWidth, arHeight, i);
        }
      } else {
        result = this.getRatio(arWidth, arHeight, i);
      }
      if (typeof result === "undefined") {
        return { arWidth: arWidth, arHeight: arHeight };
      }
      return { arWidth: result.arWidth, arHeight: result.arHeight, i: i };
    },
    getRatio(arWidth, arHeight, i) {
      var arW;
      var arH;
      if (arHeight >= 320 && arHeight < 640) {
        arH = 200;
        arW = 320;
      } else {
        arH = 200 * i;
        arW = 320 * i;
      }
      return { arWidth: arW, arHeight: arH };
    },
    getMaxAspectRatioOverVideo(
      arWidth,
      arHeight,
      videoWidth,
      videoHeight,
      isCedula,
      conversionValue
    ) {
      var width;
      var height;
      var arW;
      var arH;
      if (isCedula) {
        if (
          arHeight * conversionValue < videoHeight &&
          arWidth * conversionValue < videoWidth
        ) {
          width = arHeight * conversionValue;
          height = arWidth * conversionValue;
          arW = width;
          arH = height;
        } else {
          width = arHeight;
          height = arWidth;
          arW = width;
          arH = height;
        }
      } else {
        arH = arHeight * conversionValue;
        arW = arWidth * conversionValue;
      }
      return { arWidth: arW, arHeight: arH };
    },
    calculateCanvasPosition(videoWidth, videoHeight, arWidth, arHeight) {
      var x = Math.round((videoWidth - arWidth) / 2);
      var y = Math.round((videoHeight - arHeight) / 2);
      return { x: x, y: y };
    },
    insertCanvasOverVideo(
      canvas,
      context,
      videoWidth,
      videoHeight,
      arWidth,
      arHeight,
      x,
      y
    ) {
      context.font = "bold 20px verdana, sans-serif";
      context.fillStyle = "white";
      context.beginPath();
      context.lineWidth = 5;
      context.strokeStyle = "black";
      context.moveTo(x, y);
      context.lineTo(x + 30, y);
      context.moveTo(x + 2.5, y);
      context.lineTo(x + 2.5, y + 30);
      context.moveTo(arWidth + x, y);
      context.lineTo(arWidth + x - 30, y);
      context.moveTo(arWidth + x - 2.5, y);
      context.lineTo(arWidth + x - 2.5, y + 30);
      context.moveTo(x, arHeight + y);
      context.lineTo(x + 30, arHeight + y);
      context.moveTo(x + 2.5, arHeight + y);
      context.lineTo(x + 2.5, arHeight + y - 30);
      context.moveTo(arWidth + x, arHeight + y);
      context.lineTo(arWidth + x - 30, arHeight + y);
      context.moveTo(arWidth + x - 2.5, arHeight + y);
      context.lineTo(arWidth + x - 2.5, arHeight + y - 30);
      context.fillStyle = "rgba(0, 0, 0, 0.3)";
      context.fillRect(0, 0, x, videoHeight);
      context.fillRect(x, 0, videoWidth, y);
      context.fillRect(arWidth + x, y, videoWidth, arHeight);
      context.fillRect(x, arHeight + y, videoWidth, arHeight + y);
      context.stroke();
    },
    cleanCanvas(context, width, height) {
      context.clearRect(0, 0, width, height);
    },
    showInfoDetectionMessages(
      contextMsg,
      message,
      width,
      height,
      colorRect,
      colorFillRect,
      colorText,
      isDesktop,
      isPortrait
    ) {
      contextMsg.beginPath();
      if (isDesktop) {
        contextMsg.strokeStyle = colorRect;
        contextMsg.fillStyle = colorFillRect;
        contextMsg.rect(49, height - 25, width, 40);
        contextMsg.fillRect(49, height - 25, width, 40);
        contextMsg.font = "20px Open Sans";
        contextMsg.textAlign = "center";
        contextMsg.textBaseline = "middle";
        contextMsg.fillStyle = colorText;
        contextMsg.fillText(message, 49 + width / 2, height - 25 + 40 / 2);
      } else {
        contextMsg.strokeStyle = colorRect;
        contextMsg.fillStyle = colorFillRect;
        contextMsg.rect(10, height - 25, width, 30);
        contextMsg.fillRect(10, height - 25, width, 30);
        if (isPortrait) {
          contextMsg.font = "10px Open Sans";
        } else {
          contextMsg.font = "12px Open Sans";
        }
        contextMsg.textAlign = "center";
        contextMsg.textBaseline = "middle";
        contextMsg.fillStyle = colorText;
        contextMsg.fillText(message, 10 + width / 2, height - 25 + 30 / 2);
      }
      contextMsg.stroke();
    },
    cleanShowInfoDetectionMessages(contextMsg, width, height, substraction) {
      contextMsg.clearRect(0, 0, width, height - substraction);
    },
    drawCheckMark(id) {
      var start = 40;
      var mid = 60;
      var end = 120;
      var width = 5;
      var leftX = start;
      var leftY = start;
      var rightX = mid - width / 2.7;
      var rightY = mid + width / 2.7;
      var animationSpeed = 7;
      // get a reference to the canvas
      var canvasCheckMark = document.getElementById(id);
      this.contextCheckMark = canvasCheckMark.getContext("2d");
      this.contextCheckMark.lineWidth = width;
      // apply color of checkmark in html
      this.contextCheckMark.strokeStyle = "rgb(109, 230, 186)";
      for (var i = start; i < mid; i += 1) {
        var drawLeft = window.setTimeout(() => {
          this.contextCheckMark.beginPath();
          this.contextCheckMark.moveTo(start, start);
          this.contextCheckMark.lineTo(leftX, leftY);
          this.contextCheckMark.stroke();
          leftX += 1;
          leftY += 1;
        }, (1 + i * animationSpeed) / 3);
      }
      // draw right line
      for (var j = mid; j < end; j += 1) {
        var drawRight = window.setTimeout(() => {
          this.contextCheckMark.beginPath();
          this.contextCheckMark.moveTo(leftX, leftY);
          this.contextCheckMark.lineTo(rightX, rightY);
          this.contextCheckMark.stroke();
          rightX += 1;
          rightY -= 1;
        }, (1 + j * animationSpeed) / 3);
      }
    },
    setOperationStateToError() {
      //   axios.defaults.headers.common.Authorization = this.token;
      axios
        .post(
          `${this.endPoint}${"setoperationstatetoerror/"}${this.operationUuid}`
        )
        .then(
          response => {
            this.isIdentificationEnded = true;
          },
          error => {
            if (this.toErrorCounter < 3) {
              this.toErrorCounter += 1;
              this.setOperationStateToError();
            }
          }
        );
    },
    async stopRecording() {
      this.endVideoTime = new Date();
      await this.recorder.stopRecording();
      let blob = await this.recorder.getBlob();
      // rtc.invokeSaveAsDialog(blob);
      this.stopRecordCircle();
      this.sendBlobToServer(blob);
      // this.stopRecordCircle();
    },
    closeCamera() {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
    },
    sendBlobToServer(blob) {
      let videoData = {};
      videoData.domainUuid = this.domainUuid;
      videoData.videoUuid = this.videoUuid;
      this.videoDuration = this.endVideoTime - this.startVideoTime;
      if (isNaN(this.videoDuration)) {
        videoData.videoDuration = 0;
      } else {
        videoData.videoDuration = this.videoDuration;
      }
      videoData.videoSize = blob.size;
      var reader = new FileReader();
      reader.onloadend = () => {
        videoData.videoBase64 = reader.result.split(",")[1];
        this.EventBus.$emit("notify", "showLoading");
        if (this.loading) {
          this.showLoading();
        }
        clearInterval(this.endVideoTimeout);
        // axios.defaults.headers.common.Authorization = this.token;
        axios
          .post(
            `${this.endPoint}${"uploadblobwebm/"}${this.operationUuid}`,
            videoData
          )
          .then(
            responseSuccess => {
              if (this.loading) {
                this.hideLoading();
              }
              this.calculateVideoParams();
              this.closeCamera();
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.saveVideoSuccess
                );
              }
              this.EventBus.$emit("notify", "hideLoading");
              this.$router.push({ name: "resumeIdentification" });
              // this.EventBus.$emit('success', this.videoUuid);
            },
            responseError => {
              if (this.loading) {
                this.hideLoading();
              }
              if (this.snackBar) {
                this.$showSnackBar(
                  "snackbar-success",
                  this.snackBarMessages.saveVideoError
                );
              }
              this.closeCamera();
              if (!this.isIdentificationEnded) {
                this.setOperationStateToError();
              }
              this.EventBus.$emit("notify", "hideLoading");
              this.EventBus.$emit("error");
            }
          );
      };
      reader.readAsDataURL(blob);
    },
    calculateVideoParams() {
      axios
        .post(
          `${this.endPoint}${"identificationresult/"}${
            this.operationUuid
          }${"/"}${this.videoUuid}`
        )
        .then(
          () => {
            console.log(
              "Se ha realizado el calculo de la fórmula de la identificación"
            );
          },
          () => {
            console.log(
              "Ha ocurrido un error al calcular la fórmula de la identificación"
            );
          }
        );
    },
    animate(currentTime) {
      requestAnimationFrame(this.animate);
      this.contextRecordCircle.clearRect(
        0,
        0,
        this.canvasRecordCircle.width,
        this.canvasRecordCircle.height
      );

      var elapsed = currentTime - this.lastTimeRecordCircle;
      this.lastTimeRecordCircle = currentTime;

      // for (var i in this.circles) {
      var circle = this.circles.red;
      circle.visibleCountdown -= elapsed;
      if (circle.visibleCountdown > 0) {
        this.drawRecordCircle(circle);
      }
      // }
    },
    drawRecordCircle(circle) {
      this.contextRecordCircle.globalAlpha =
        circle.visibleCountdown / circle.visibleDuration;
      this.contextRecordCircle.beginPath();
      this.contextRecordCircle.arc(
        circle.x,
        circle.y,
        circle.radius,
        0,
        Math.PI * 2
      );
      this.contextRecordCircle.closePath();
      this.contextRecordCircle.fillStyle = circle.color;
      this.contextRecordCircle.fill();
      this.contextRecordCircle.globalAlpha = 1.0;
    },
    showRecordCircle(circle) {
      circle.visibleCountdown = circle.visibleDuration;
    },
    stopRecordCircle() {
      clearInterval(this.intervalRecordCircle);
    }
  }
};
</script>

<style>
#video {
  position: absolute;
  width: 640px;
  height: 480px;
  background: black;
}
.videoTransition {
  border: 1px solid black;
  box-shadow: 3px 5px 15px #1a1a1a;
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg); /* Safari and Chrome */
  -moz-transform: rotateY(180deg); /* Firefox */
}
.videoNoTransition {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
  border: 1px solid black;
  box-shadow: 3px 5px 15px #1a1a1a;
}
#canvas {
  visibility: hidden;
  position: absolute;
}
#canvasGuide {
  z-index: 1;
  position: absolute;
}
#canvasMessages {
  z-index: 2;
  position: absolute;
}
#canvasRectangle {
  z-index: 2;
  position: absolute;
}
#canvasCheckMark {
  z-index: 2;
  position: absolute;
  margin-top: 25px;
  left: 480px;
}
#canvasRecordCircle {
  z-index: 2;
  position: absolute;
  left: 610px;
}
#canvasLiveness {
  z-index: 2;
  position: absolute;
}
.pointCanvas {
  z-index: 2;
  position: absolute;
}
#canvasVideo {
  position: absolute;
  visibility: hidden;
}
.centerHorizontalAbsolute {
  top: 25%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
</style>
